import { Controller } from '../utils/controller';
import { IShade } from '../models/product';

export default class extends Controller {
  static targets = [
    'trigger',
    'list',
    'selectedShade',
    'selectedShadeStriketrough',
    'selectedTitle',
    'chevron'
  ];
  static values = {
    selected: String,
    listVisible: Boolean,
    shades: Array
  };

  declare triggerTarget: HTMLDivElement;
  declare listTarget: HTMLDivElement;
  declare selectedShadeTarget: HTMLSpanElement;
  declare selectedShadeStriketroughTarget: HTMLSpanElement;
  declare selectedTitleTarget: HTMLSpanElement;
  declare chevronTarget: HTMLDivElement;

  declare hasSelectedShadeTarget: boolean;
  declare hasSelectedShadeStriketroughTarget: boolean;
  declare hasSelectedTitleTarget: boolean;
  declare hasChevronTarget: boolean;
  declare hasTriggerTarget: boolean;

  declare selectedValue: string;
  declare listVisibleValue: boolean;
  declare shadesValue: IShade[];

  connect(): void {
    this.triggerTarget.addEventListener('click', this.onTriggerClick);
  }

  onTriggerClick = (e: Event) => {
    e.preventDefault();

    if (e.type === 'click') {
      this.toggleListDisplay();
    }
  };

  toggleListDisplay() {
    this.listVisibleValue = !this.listVisibleValue;
  }

  onSelect(e: Event) {
    e.preventDefault();
    const value = e?.params?.skuId || e?.target?.dataset?.name;

    if (value) {
      this.selectedValue = value;
    }

    this.listVisibleValue = false;
  }

  skuSelected = (data) => {
    if (data?.detail?.triggerrer !== this) {
      // eslint-disable-next-line no-console
      console.log(data);
    }
  };

  selectedValueChanged(val, prev) {
    if (val === prev) {
      return null;
    }

    const selectedShade = this.shadesValue.find((shade) => shade.sku_id === val);

    if (selectedShade) {
      if (this.hasSelectedShadeTarget) {
        this.selectedShadeTarget.style.backgroundColor = selectedShade.hex_value;
      }
      if (this.hasSelectedShadeStriketroughTarget) {
        if (selectedShade['is_shoppable?']) {
          this.selectedShadeStriketroughTarget.classList.add('hidden');
        } else {
          this.selectedShadeStriketroughTarget.classList.remove('hidden');
        }
      }
      if (this.hasTriggerTarget) {
        this.triggerTarget.setAttribute('title', selectedShade.title);
      }
      if (this.hasSelectedTitleTarget) {
        this.selectedTitleTarget.textContent = selectedShade.title;
        this.selectedTitleTarget.setAttribute('title', selectedShade.title);
      }
    }
  }

  listVisibleValueChanged(listVisible, prev) {
    if (listVisible === prev) {
      return null;
    }

    if (listVisible) {
      this.listTarget.classList.remove('hidden');
      this.chevronTarget.classList.add('is-open');
    } else {
      this.listTarget.classList.add('hidden');
      this.chevronTarget.classList.remove('is-open');
    }
  }
}
